import { FC } from 'react';

import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginBottom: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.error.main}`,
    backgroundColor: 'transparent',
    color: theme.palette.error.main,
  },
}));

export type FormErrorBannerProps = {
  message: string | null;
};

/** Inline non-blocking error message shown above forms when a mutation fails. */
const FormErrorBanner: FC<FormErrorBannerProps> = ({ message }) => {
  const classes = useStyles();
  const open = !!message;

  return (
    <Collapse in={open} unmountOnExit>
      <Box className={classes.wrapper}>
        <Box className={classes.root} role='alert'>
          <Typography color='inherit' variant='body2'>
            {message}
          </Typography>
        </Box>
      </Box>
    </Collapse>
  );
};

export default FormErrorBanner;
